/* tslint:disable */
/* eslint-disable */
/**
 * SLOeats API
 * Interal API to the SLOeats platform.
 *
 * The version of the OpenAPI document: 
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ReelDeal } from './ReelDeal';
import {
    ReelDealFromJSON,
    ReelDealFromJSONTyped,
    ReelDealToJSON,
} from './ReelDeal';

/**
 * 
 * @export
 * @interface DealRewardReelDeal
 */
export interface DealRewardReelDeal {
    /**
     * 
     * @type {number}
     * @memberof DealRewardReelDeal
     */
    readonly id: number;
    /**
     * 
     * @type {string}
     * @memberof DealRewardReelDeal
     */
    readonly name: string;
}

/**
 * Check if a given object implements the DealRewardReelDeal interface.
 */
export function instanceOfDealRewardReelDeal(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "name" in value;

    return isInstance;
}

export function DealRewardReelDealFromJSON(json: any): DealRewardReelDeal {
    return DealRewardReelDealFromJSONTyped(json, false);
}

export function DealRewardReelDealFromJSONTyped(json: any, ignoreDiscriminator: boolean): DealRewardReelDeal {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
    };
}

export function DealRewardReelDealToJSON(value?: DealRewardReelDeal | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
    };
}

